/**
 * Normalizzazione numeri di telefono per la ricerca (globale, filtro Lead, filtro Clienti).
 * Il campo phone è testo libero e il prefisso internazionale è salvato a parte in
 * country_code: due numeri identici possono essere scritti in modo diverso record per
 * record (spazi, trattini, con/senza prefisso). Confrontare solo le cifre elimina la
 * maggior parte dei mancati match.
 */

export function normalizePhoneDigits(value?: string | null): string {
  return (value || '').replace(/\D/g, '');
}

/**
 * Genera le varianti di cifre da usare per il match, per coprire anche il caso in cui
 * l'utente digiti il prefisso internazionale ma il dato salvato non lo includa (o
 * viceversa, già coperto dal semplice "contains" perché il numero locale è una
 * sottostringa del numero con prefisso).
 */
export function buildPhoneDigitPatterns(query: string): string[] {
  const digits = normalizePhoneDigits(query);
  if (!digits) return [];

  const patterns = new Set<string>([digits]);
  if (digits.startsWith('0039') && digits.length > 4) {
    patterns.add(digits.slice(4));
  } else if (digits.startsWith('39') && digits.length > 9) {
    patterns.add(digits.slice(2));
  }
  return [...patterns];
}

/** True se il valore telefonico salvato (eventualmente con country_code) contiene la query digitata. */
export function phoneMatchesQuery(phone: string | null | undefined, countryCode: string | null | undefined, query: string): boolean {
  const patterns = buildPhoneDigitPatterns(query);
  if (patterns.length === 0) return false;
  const stored = normalizePhoneDigits(`${countryCode || ''}${phone || ''}`);
  if (!stored) return false;
  return patterns.some(p => stored.includes(p));
}
